import { render, staticRenderFns } from "./signatureComponent.vue?vue&type=template&id=252d803e&scoped=true"
import script from "./signatureComponent.vue?vue&type=script&lang=js"
export * from "./signatureComponent.vue?vue&type=script&lang=js"
import style0 from "./signatureComponent.vue?vue&type=style&index=0&id=252d803e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252d803e",
  null
  
)

export default component.exports